import _findIndexInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/find-index";
// 是否是叶子节点
export default function isGroupColumn(columns) {
  return _findIndexInstanceProperty(columns).call(columns, function (col) {
    return col.children && col.children.length > 0;
  }) > -1;
}